export function validatorFn({ newResource }) {
  const locked = newResource.getData('routeLock')
  const available = newResource.getData('available')

  const valid = available && !locked
  return {
    valid,
  }
}
